import { TreeNode } from '../route-builder';

export const SpecialPaymentModule = {
  segment: 'special-recognition',
  children: {
    SpecialPaymentComponent: {
      segment: '',
      children: {
        SpecialPaymentIntroductionComponent: { segment: 'introduction' },
        SpecialPaymentMyDashboardComponent: { segment: 'my-dashboard' },
        SpecialPaymentProposalsComponent: { segment: 'proposals', params: ['employeeId', 'proposalId'] }
      }
    }
  }
} as const satisfies TreeNode;
